import { Link } from 'react-router-dom';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';

export const MemoryCard = ({ memory }) => {
  return (
    <Link
      to={`/memories/${memory.slug}`}
      className="memory-card group block"
      data-testid={`memory-card-${memory.slug}`}
    >
      {/* Image Container */}
      <div className="relative overflow-hidden h-64 md:h-72">
        <img
          src={memory.heroImage}
          alt={memory.title}
          className="memory-card-image"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0505] via-transparent to-transparent" />
        
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-[#722F37]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Subtitle */}
        <p className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase mb-2">
          {memory.subtitle}
        </p>

        {/* Title */}
        <h3 className="font-['Playfair_Display'] text-xl md:text-2xl text-[#F5F5F0] mb-3 group-hover:text-[#D4AF37] transition-colors">
          {memory.title}
        </h3>

        {/* Meta Info */}
        <div className="flex items-center gap-4 text-[#A18E90] text-sm mb-4">
          <span className="flex items-center gap-1.5">
            <Calendar className="w-4 h-4" />
            {memory.date}
          </span>
          <span className="flex items-center gap-1.5">
            <MapPin className="w-4 h-4" />
            {memory.location}
          </span>
        </div>

        {/* Description */}
        <p className="text-[#A18E90] text-sm leading-relaxed line-clamp-2 mb-4">
          {memory.shortDescription}
        </p>

        {/* Read More */}
        <div className="flex items-center gap-2 text-[#D4AF37] text-sm font-medium group-hover:gap-3 transition-all">
          <span>View Memory</span>
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
};
